/**
 * Day-range query — mirrors mobile's use-days-range.ts.
 *
 * Fetches GET /me/days?from=&to= which returns one DaySummary per calendar
 * date in [from, to] inclusive, plus 7-day and 28-day rolling averages.
 * Used by the home page KPI cards.
 */
import type { components } from '@nutians/api-client';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api.js';

type DaysRangeResponse = components['schemas']['DaysRangeResponse'];

export function daysRangeKey(from: string, to: string): readonly [string, string, string, string] {
  return ['days', 'range', from, to] as const;
}

export function useDaysRange(from: string, to: string, enabled = true) {
  return useQuery<DaysRangeResponse>({
    queryKey: daysRangeKey(from, to),
    queryFn: async () => {
      const { data, error } = await api.GET('/me/days', {
        params: { query: { from, to } },
      });
      if (error || !data) throw new Error(`GET /me/days?from=${from}&to=${to} failed`);
      return data;
    },
    enabled,
    staleTime: 60_000,
    retry: false,
  });
}
